import { atom } from 'jotai';

import {
  cycleCountSchedulesQueryAtom,
  type CycleCountScheduleSortOption,
} from '../_graphql/queryCycleCountSchedules';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $selectedFacility = atomFromQueryString.string('f');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<CycleCountScheduleSortOption[]>([
  'NameAsc',
]);

export const $isCreateDialogOpen = atom(false);

export const $remoteCycleCountSchedules = cycleCountSchedulesQueryAtom(
  (get) => {
    const selectedFacility = get($selectedFacility);
    const limit = get($limit);
    const offset = get($offset);
    const sorting = get($currentSorting);

    const params: {
      facilityIds?: string[];
      limit: number;
      offset: number;
      sorting: CycleCountScheduleSortOption[];
    } = {
      limit,
      offset,
      sorting,
    };

    if (selectedFacility && selectedFacility !== 'all') {
      params.facilityIds = [selectedFacility];
    }

    return {
      variables: params,
    };
  },
);
